export default __webpack_public_path__ + "39890742bc957b368704509bb2f4163c.woff2";